import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { BootLoader } from '@pc/ui';
import { useVendorContext } from './VendorContext';

/**
 * Three-state gate for the sell app shell:
 *
 *   * 0 memberships  -> /onboarding-application (collect slug + company
 *                       + TOS; auth has already happened upstream at
 *                       auth.peptideclients.com)
 *   * 1+ memberships, no active selection -> /choose-storefront
 *   * 1+ memberships, active selection    -> render children
 */
export function RequireVendor() {
  const { ready, vendor, available } = useVendorContext();
  const { t } = useTranslation();
  const location = useLocation();
  if (!ready) {
    return <BootLoader label={t('auth.requireVendor.loading', 'Loading')} />;
  }
  if (available.length === 0) {
    return <Navigate to="/onboarding-application" replace />;
  }
  if (!vendor) {
    if (location.pathname === '/choose-storefront') return <Outlet />;
    return <Navigate to="/choose-storefront" replace />;
  }
  return <Outlet />;
}
